export default "__VITE_ASSET__A7AENb7p__"